import {
  NOTIFICATIONS_TYPE,
  NOTIFICATION_CATEGORIES,
  NOTIFICATION_CATEGORIES_TITLES,
  NOTIFICATION_DOWNLOAD_ACTIONS_TYPES
} from '../constants/notificationsConstants'

angular.module('common.services').factory('notificationsFactory', [
  '$http',
  '$filter',
  '$localStorage',
  '$q',
  '$window',
  '$timeout',
  function ($http, $filter, $localStorage, $q, $window, $timeout) {
    this.list = []
    const isMobile = window.innerWidth < 768
    this.page = 1
    this.pageSize = isMobile ? 20 : 5
    this.downloadedList = {}
    this.clear = function () {
      this.list = []
      this.page = 1
    }

    this.calculateDownloadTimeAgo = downloadTimeMs => {
      const downloadTime = new Date(downloadTimeMs)
      const currentTime = new Date()
      const timeDiff = currentTime - downloadTime
      const totalMinutes = Math.floor(timeDiff / 1000 / 60)
      if (totalMinutes <= 30) {
        return 'Now'
      } else if (totalMinutes <= 60) {
        return '1 hour ago'
      } else {
        const hoursAgo = Math.ceil(totalMinutes / 60)
        return `${hoursAgo} hours ago`
      }
    }
    this.formatFileSize = sizeInBytes => {
      let size
      if (sizeInBytes < 1024 * 1024) {
        size = Math.round(sizeInBytes / 1024).toString()
        return `${size} KB`
      } else {
        size = Math.round(sizeInBytes / 1024 / 1024).toString()
        return `${size} MB`
      }
    }
    function delay (ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    }
    this.handleDownloadNotification = async downloadNotifications => {
      try {
        const recordingDownloadObjects = []
        const reportDownloadObjects = []
        const recordingDownloadActionObjects = []
        const reportDownloadActionObjects = []
        downloadNotifications.forEach(({ type, uuid, metadata }) => {
          if (
            NOTIFICATIONS_TYPE[type].notificationCategory ===
            NOTIFICATION_CATEGORIES.RECORDING
          ) {
            const { imei } = metadata || {}
            recordingDownloadObjects.push({ uuid, imei })
            recordingDownloadActionObjects.push({
              uuid,
              imei,
              actionType:
                NOTIFICATION_DOWNLOAD_ACTIONS_TYPES.AUTO_DOWNLOAD_RECORDING_FILE
            })
          } else if (
            NOTIFICATIONS_TYPE[type].notificationCategory ===
            NOTIFICATION_CATEGORIES.REPORTS
          ) {
            reportDownloadObjects.push({
              uuid,
              job_type: type
            })
            reportDownloadActionObjects.push({
              uuid,
              job_type: type,
              actionType:
                NOTIFICATION_DOWNLOAD_ACTIONS_TYPES.AUTO_DOWNLOAD_RECORDING_FILE
            })
          }
        })

        const requestJson = {
          method: 'POST',
          url: `${DEVICEMANAGER_BASEURL}/device/notification-download/bulk-presigned-link`,
          data: {
            ...(recordingDownloadObjects.length > 0
              ? { recordingDownloadObjects }
              : {}),
            ...(reportDownloadObjects.length > 0
              ? { reportDownloadObjects }
              : {})
          }
        }
        const { data: urls } = await $http(requestJson)
        const notificationsToDownload = urls.data
        for (let index = 0; index < notificationsToDownload.length; index++) {
          const url = notificationsToDownload[index]
          try {
            const downloadedUrl = new URL(url).pathname
            if (url && !this.downloadedList[downloadedUrl]) {
              await delay(2000)
              const anchor = document.createElement('a')
              anchor.href = url
              document.body.appendChild(anchor)
              anchor.click()
              document.body.removeChild(anchor)
              this.downloadedList[downloadedUrl] = true
            }
          } catch (error) {
            console.error('Error while downloading file: ', error)
          }
        }
        try {
          const requestJson = {
            method: 'POST',
            url: `${DEVICEMANAGER_BASEURL}/device/bulk-notification-download-action`,
            data: {
              ...(recordingDownloadActionObjects.length > 0
                ? { recordingDownloadActionObjects }
                : {}),
              ...(reportDownloadActionObjects.length > 0
                ? { reportDownloadActionObjects }
                : {})
            }
          }
          await $http(requestJson)
        } catch (error) {
          console.error(
            'Error while sending auto-download complete request: ',
            error
          )
        }
      } catch (error) {
        console.error(
          'Error while downloading file - handleDownloadNotification',
          error
        )
      }
    }
    /**
     * @name checkUnReadNotifications
     * @desc Get all notifications
     * @returns {Promise} Notifications
     */
    this.checkUnReadNotifications = async function () {
      return $http({
        method: 'GET',
        url: USER_BASEURL + '/notifications/unread'
      })
        .then(function (response) {
          const data = response.data.data
          return data
        })
        .catch(function (err) {
          console.log('error while fetching notifications = ', err)
        })
    }

    this.loadMoreNotifications = async function () {
      return $http({
        method: 'GET',
        url:
          USER_BASEURL +
          `/notifications?page=${this.page}&limit=${this.pageSize}`
      })
        .then(async ({ data: { data } }) => {
          const parsedNotifications = data.map(notification => {
            if (
              [
                'recording-download',
                'downloadDevicesDataUsageReport',
                'downloadDevicesHealthReport',
                'downloadDevicesAlarmsReport'
              ].includes(notification.type)
            ) {
              const { metadata, type } = notification
              const { size, timestamp } = metadata

              notification.title = NOTIFICATION_CATEGORIES_TITLES[
                NOTIFICATIONS_TYPE[notification.type].notificationCategory
              ](
                notification.metadata,
                NOTIFICATIONS_TYPE[notification.type].notificationTitle
              )
              notification.category =
                NOTIFICATIONS_TYPE[notification.type].notificationCategory
              if (size !== undefined && size !== null) {
                notification.size = this.formatFileSize(size)
              }
              if (metadata.status === 'completed') {
                notification.downloadedAt = this.calculateDownloadTimeAgo(
                  timestamp
                )
              }
            }
            return notification
          })
          this.list = [...this.list, ...parsedNotifications]
          this.page += 1
          // If notifications were read without being downloaded, then download them
          const downloadNotifications =
            parsedNotifications &&
            parsedNotifications.filter(
              notifications =>
                [
                  'recording-download',
                  'downloadDevicesDataUsageReport',
                  'downloadDevicesHealthReport',
                  'downloadDevicesAlarmsReport'
                ].includes(notifications.type) &&
                notifications.metadata.status === 'completed' &&
                notifications.metadata.autoDownloaded === false
            )

          if (downloadNotifications && downloadNotifications.length) {
            this.handleDownloadNotification(downloadNotifications)
          }
          return parsedNotifications
        })
        .catch(err => {
          console.log('error while fetching notifications = ', err)
        })
    }
    return this
  }
])
